import { render, staticRenderFns } from "./LottoStats.vue?vue&type=template&id=44a80fb9&scoped=true&lang=pug"
import script from "./LottoStats.vue?vue&type=script&lang=js"
export * from "./LottoStats.vue?vue&type=script&lang=js"
import style0 from "./LottoStats.vue?vue&type=style&index=0&id=44a80fb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a80fb9",
  null
  
)

export default component.exports